import { render, staticRenderFns } from "./ToolTutorialRecommendations.vue?vue&type=template&id=90396c92&"
import script from "./ToolTutorialRecommendations.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ToolTutorialRecommendations.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports